import React from 'react'
import getTransitionStyle from '../utils/getTransitionStyle'
import Footer from '../components/Footer'
import Menu from '../components/Menu'
import RequestContactForm from '../components/RequestContactForm'
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import PageAnimations from '../components/PageAnimations'
import styles from '../utils/mapStyles'
import { compose, withHandlers } from 'recompose'
import { HelmetDatoCms } from 'gatsby-source-datocms'
import { FormattedMessage } from 'react-intl'
import marker from '../images/logo-marker.png'
import smoothScroll from 'smoothscroll';
import sortAlphabetically from '../utils/sortAlphabetically'

export default class Contact extends React.Component {
  componentWillMount() {
    if (this.props.location.hash === "#eshop") {
      setTimeout(() => {
        smoothScroll(this.onlineShops, 2000)
      }, 3000)
    }
  }

  render() {
    const status = this.props.transition ? this.props.transition.status : "entering"
    const menuStyle = getTransitionStyle(status, 200, 2000, 'menuStyle')
    const timeout = 800
    const delay = 1000
    const sectionAppears = getTransitionStyle(
      status, timeout, 1000, 'pageAppearsFromBottom'
    )
    const { data } = this.props;

    return(
      <div
        className="page"
        style={{ backgroundColor: '#FFF' }}
      >
        <HelmetDatoCms
          seo={data.page.seo}
          favicon={data.site.favicon}
        />

        <Menu
          style={menuStyle}
          hasWhiteLogo={false}
          data={data}
        />

        <PageAnimations
          status={status}
          timeout={timeout}
          delay={timeout}
          color={`#FFF`}
        />

        <div className="wrap">
          <div style={sectionAppears}>
            <h1 className="page__title--dark">
              {data.page.title}
            </h1>
            <RequestContactForm
              address={data.page.headquarterAddress}
            />
          </div>
        </div>

        <Footer showCta={false} data={this.props.data} />
      </div>
    )
  }
}

export const query = graphql`
  query ContactQuery($locale: String!) {
    page: datoCmsContact(locale: { eq: $locale }) {
      title
      marker {
        resize(width: 40, imgixParams: { auto: "compress" }) {
          src
        }
      }
      themeColor { hex }
      headquarterAddress: headquarterAddressNode {
        markdown: childMarkdownRemark {
          html
        }
      }
      seo: seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }

    site: datoCmsSite {
      favicon: faviconMetaTags {
        ...GatsbyDatoCmsFaviconMetaTags
      }
    }

    distributors: allDatoCmsDistributor(filter: { locale: { eq: $locale } } ) {
      edges {
        node {
          id
          name
          address
          phoneNumber
          website
          servedCountries {
            name
          }
          coordinates {
            latitude
            longitude
          }
        }
      }
    }

    menuHomepage:           datoCmsHomepage(locale: { eq: $locale })           { menuTitle themeColor { hex } }
    menuInterchangeability: datoCmsInterchangeability(locale: { eq: $locale }) { menuTitle themeColor { hex } slug }
    menuPhilosophy:         datoCmsPhilosophy(locale: { eq: $locale })         { menuTitle themeColor { hex } slug }
    menuNews:               datoCmsNewsHome(locale: { eq: $locale })           { menuTitle themeColor { hex } slug }
    menuAbout:              datoCmsAbout(locale: { eq: $locale })              { menuTitle themeColor { hex } slug }
    menuContact:            datoCmsContact(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuCatalog:            datoCmsCatalog(locale: { eq: $locale })            { menuTitle themeColor { hex } slug }
    menuDownload:           datoCmsDownloadArea(locale: { eq: $locale })       { menuTitle themeColor { hex } slug }
    menuDesigners:          datoCmsDesignersPage(locale: { eq: $locale })      { menuTitle themeColor { hex } slug }
    menuFooter:             datoCmsFooter                                      { facebook instagram twitter youtube pinterest companyName address: addressNode { markdown: childMarkdownRemark { html } } googleMapsUrl phoneNumber faxNumber vat emailAddress newsletterTitle newsletterDescription}
  }
`
// agents: allDatoCmsAgent(filter: { locale: { eq: $locale } }) {
//       edges {
//         node {
//           id
//           name
//           address
//           website
//           phoneNumber
//           servedCountries {
//             name
//           }
//           coordinates {
//             latitude
//             longitude
//           }
//         }
//       }
//     }
//     onlineShops: allDatoCmsOnlineShop(filter: { locale: { eq: $locale } }) {
//       edges {
//         node {
//           id
//           servedCountries {
//             name
//           }
//           email
//           name
//           website
//           phoneNumber
//         }
//       }
//     }
// shops: allDatoCms(filter: { locale: { eq: $locale } }) {
//   edges {
//     node {
//       id
//       name
//       address
//       website
//       country {
//         name
//       }
//       coordinates {
//         latitude
//         longitude
//       }
//     }
//   }
// }
//
// <div className="contact__shops">
//   <div className="contact__shops__title">
//     Shops
//   </div>
//   <table>
//     <thead>
//       <tr>
//         <th>Name</th>
//         <th>Address</th>
//       </tr>
//     </thead>
//     <tbody>
//       {
//         shops.edges.map(({ node: shop }) => (
//           <tr key={shop.id}>
//             <td>
//               <a className="contact__shops__link" href={shop.website} target="_blank">
//                 {shop.name}
//               </a>
//             </td>
//             <td>{shop.address}</td>
//           </tr>
//         ))
//       }
//     </tbody>
//   </table>
// </div>



// WEBPACK FOOTER //
// ./src/templates/contact.js